import { Card, CardContent, Typography, styled } from "@mui/material";
import Skeleton from "react-loading-skeleton";
import { IWithClassName, IWithThemeProps } from "../../../theme/default.theme";
import CollapsibleFAQ, { IFAQProps } from "./collapsible-faq";

interface IFAQSection {
    title: string;
    slug: string;
    faqs: Array<IFAQProps>;
    isLoading: boolean;
}

const FAQSection = ({
    className,
    title,
    slug,
    faqs,
    isLoading,
}: IWithClassName & IFAQSection) => (
    <div id={slug} className={className}>
        <Card>
            <CardContent>
                {isLoading ? (
                    <span className="heading-loader">
                        <Skeleton />
                    </span>
                ) : (
                    <Typography variant="h5" component="h2">
                        {title}
                    </Typography>
                )}
            </CardContent>
        </Card>
        {faqs.map((faq, index) => (
            <CollapsibleFAQ
                key={`${slug}-${faq.slug ?? index}`}
                question={faq.question}
                answer={faq.answer}
                slug={`${slug}-${faq.slug ?? index}`}
                className="collapsible-faq"
                isLoading={isLoading}
            />
        ))}
    </div>
);

export default styled(FAQSection)(({ theme }: IWithThemeProps) => ({
    marginBottom: theme?.spacing(5),

    ".MuiCard-root": {
        borderRadius: "20px 20px 0 0",
        borderBottom: `1px solid ${
            theme?.palette.faqSection.borderColor ?? ""
        }`,
    },
    ".MuiTypography-root": {
        color: theme?.palette.faqSection.textColor,
    },
    ".MuiTypography-h5": {
        fontSize: 22,
        fontWeight: 600,
    },
    "& > .collapsible-faq:last-child": {
        borderRadius: "0 0 20px 20px",
        borderBottom: "none",
    },
    ".heading-loader": {
        width: 200,
        display: "grid",
    },
}));
